export const VARIANT_TYPE = Object.freeze({
  DANGER: 'danger',
  INFO: 'info',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning',
});

export const emitToast = (component,variantType,message, title='Info') => {
  let variant;
  switch (variantType){
    case VARIANT_TYPE.PRIMARY:
      variant = VARIANT_TYPE.PRIMARY;
      title = 'Good News!';
      break;
    case VARIANT_TYPE.DANGER:
      variant = VARIANT_TYPE.DANGER;
      title = 'Oops!';
      break;
    case VARIANT_TYPE.WARNING:
      variant = VARIANT_TYPE.WARNING;
      title = 'Heads Up!';
      break;
    case VARIANT_TYPE.SUCCESS:
      variant = VARIANT_TYPE.SUCCESS;
      title = 'Awesome!';
      break;
    case VARIANT_TYPE.INFO:
      variant = VARIANT_TYPE.INFO;
      title = 'Just So You Know...';
      break;
    default:
      variant = 'default';

  }

  component.toast(message,{
    noAutoHide: false,
    title,
    toaster: 'b-toaster-bottom-right',
    variant,
  });
};
